"use strict";
/**
 * The primary entrypoint for the Inngest SDK. This provides all the necessary
 * exports to create, run, and trigger Inngest functions.
 *
 * Typical usage involves creating a new Inngest client with `Inngest`, and then
 * using the client to create functions, middleware, and other tools.
 *
 * See {@link https://www.inngest.com/docs} for more information.
 *
 * @example Create an Inngest client
 * ```ts
 * const inngest = new Inngest({
 *   id: "my-app-id",
 * });
 * ```
 *
 * @example Create an Inngest function
 * ```ts
 * const myFn = inngest.createFunction({
 *  id: "my-function",
 * }, {
 *   event: "user/created",
 * }, async ({ event, step }) => {
 *   console.log("User created:", event.data);
 * });
 * ```
 *
 * @example Send an event
 * ```ts
 * await inngest.send({
 *   name: "user/created",
 *   data: {
 *     id: "123",
 *   },
 * });
 * ```
 *
 * @module
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProxyLogger = exports.slugify = exports.queryKeys = exports.internalEvents = exports.headerKeys = exports.StepError = exports.RetryAfterError = exports.NonRetriableError = exports.InngestMiddleware = exports.referenceFunction = exports.InngestCommHandler = exports.Inngest = exports.EventSchemas = void 0;
var EventSchemas_1 = require("./components/EventSchemas");
Object.defineProperty(exports, "EventSchemas", { enumerable: true, get: function () { return EventSchemas_1.EventSchemas; } });
var Inngest_1 = require("./components/Inngest");
Object.defineProperty(exports, "Inngest", { enumerable: true, get: function () { return Inngest_1.Inngest; } });
var InngestCommHandler_1 = require("./components/InngestCommHandler");
Object.defineProperty(exports, "InngestCommHandler", { enumerable: true, get: function () { return InngestCommHandler_1.InngestCommHandler; } });
var InngestFunctionReference_1 = require("./components/InngestFunctionReference");
Object.defineProperty(exports, "referenceFunction", { enumerable: true, get: function () { return InngestFunctionReference_1.referenceFunction; } });
var InngestMiddleware_1 = require("./components/InngestMiddleware");
Object.defineProperty(exports, "InngestMiddleware", { enumerable: true, get: function () { return InngestMiddleware_1.InngestMiddleware; } });
var NonRetriableError_1 = require("./components/NonRetriableError");
Object.defineProperty(exports, "NonRetriableError", { enumerable: true, get: function () { return NonRetriableError_1.NonRetriableError; } });
var RetryAfterError_1 = require("./components/RetryAfterError");
Object.defineProperty(exports, "RetryAfterError", { enumerable: true, get: function () { return RetryAfterError_1.RetryAfterError; } });
var StepError_1 = require("./components/StepError");
Object.defineProperty(exports, "StepError", { enumerable: true, get: function () { return StepError_1.StepError; } });
var consts_1 = require("./helpers/consts");
Object.defineProperty(exports, "headerKeys", { enumerable: true, get: function () { return consts_1.headerKeys; } });
Object.defineProperty(exports, "internalEvents", { enumerable: true, get: function () { return consts_1.internalEvents; } });
Object.defineProperty(exports, "queryKeys", { enumerable: true, get: function () { return consts_1.queryKeys; } });
var strings_1 = require("./helpers/strings");
Object.defineProperty(exports, "slugify", { enumerable: true, get: function () { return strings_1.slugify; } });
var logger_1 = require("./middleware/logger");
Object.defineProperty(exports, "ProxyLogger", { enumerable: true, get: function () { return logger_1.ProxyLogger; } });
//# sourceMappingURL=index.js.map